enum EApiUploader {
  uploadRequest = '/documents/temp-upload',
}

export default EApiUploader;
